import API from './_instance';
import axios from 'axios';

const FivemApi = axios.create({
  baseURL: 'https://servers-frontend.fivem.net/api/servers/single',
  timeout: 1000,
});

export const fetchServerStatus = async () => {
  const { data } = await FivemApi.get('/m4v7dq');

  return data;
};

export const fetchNews = async () => {
  const { data } = await API.get("/news");

  return data;
};

export const fetchBans = async () => {
  const { data } = await API.get("/admin/bans");

  return data;
};

export const fetchTopics = async ({ forumId }) => {
  const { data } = await API.get("/forums/topics", {
    params: {
      forumId,
    },
  });

  return data;
};

export const createTopic = async ({ forumId, topicName, content, isSticky, isLocked }) => {
  const { data } = await API.post("/forums/topics",
    {
      forumId,
      topicName,
      content,
      isSticky,
      isLocked,
    }
  );

  return data;
};

export const fetchCharacters = async ({ currentPage, sortBy, sortOrder, itemsPerPage }) => {
  const { data } = await API.get("/admin/characters", {
    params: {
      currentPage,
      sortBy,
      sortOrder,
      itemsPerPage,
    },
  });

  return data;
};

export const fetchForbes = async () => {
  const { data } = await API.get("/admin/forbes");

  return data;
};

export const fetchVehicles = async () => {
  const { data } = await API.get("/admin/vehicles");

  return data;
};

export const fetchVehicle = async ({ plate }) => {
  const { data } = await API.get("/admin/vehicle", {
    params: {
      plate
    },
  });

  return data;
};

export const fetchCharacter = async ({ cid }) => {
  const { data } = await API.get("/admin/character", {
    params: {
      cid
    },
  });

  return data;
};

export const fetchCharacterInventory = async ({ cid }) => {
  const { data } = await API.get("/admin/inventory", {
    params: {
      cid
    },
  });

  return data;
};

export const fetchCharacterVehicles = async ({ cid }) => {
  const { data } = await API.get("/admin/character/vehicles", {
    params: {
      cid
    },
  });

  return data;
};

export const fetchPermissions = async () => {
  const { data } = await API.get("/admin/permissions");

  return data;
};